<template>
    <section>
        <div class="join_section1" style="position: relative;">
            <div class="mobile_con_wrap" style="display: flex; flex-direction: column; align-items: flex-start; justify-content: flex-end; padding-top: calc((var(--vh, 1vh) * 100) - 496px); padding-bottom: 133px;">
                <p data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" style="font-size: 30px; font-weight: 300; text-align: left; margin-bottom: 33px;">
                    에듀테크 시장을 함께<br>
                    선도해나갈<br>
                    동료를 찾습니다.
                </p>
                <img src="@/assets/images/main_v2/mobile_background_section5.png" alt="" style="width: 100%;">
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
export default {
    components: {
        ChevronDownIcon
    }
    
}
</script>
<style>
    .join_section1 {
        width: 100vw;
        height: calc(var(--vh, 1vh) * 100);
        object-fit: inherit;
    }
</style>